import SideModal from "components/SideModal";
import { useTranslation } from "contexts/i18nContext";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useState } from "react";
import { addCouncilLitigationAttendance } from "services/prosecutorDecipilineService";
import { CouncilLitigation } from "types";
import { LoadingIcon } from "utils/constant";
import "../../complaintRequest/styles/AddEvidenceModal.css";

interface FeedbackModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  litigationData: CouncilLitigation;
  onRefresh: any;
}

export default function AddCouncilMeetingAttendance({
  isOpen,
  setIsOpen,
  litigationData,
  onRefresh,
}: FeedbackModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();

  // const [query, setQuery] = useState("");
  // const [showDropdown, setShowDropdown] = useState(false);
  // const [employeesData, setEmployeesData] = useState<any[]>([]);

  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  interface Employee {
    uu_id: string;
    full_name: string;
    english_first_name?: string;
    english_middle_name?: string;
    english_last_name?: string;
    employee_type?: string;
    // add other fields as needed
  }

  const [formState, setFormState] = useState<{
    council_member: string;
    selected_employee: Employee | null;
    was_present: string;
    remark: string;
  }>({
    council_member: "",
    selected_employee: null as any,
    was_present: "true",
    remark: "",
  });

  // useEffect(() => {
  //   if (!query) return;

  //   const loadEmployees = async () => {
  //     setLoading(true);

  //     try {
  //       const data = await fetchEmployees(query);
  //       setEmployeesData(data);
  //       setError("");
  //     } catch (err) {
  //      setError("Failed to load prosecutors.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   loadEmployees();
  // }, [query]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // const handleAccusedProsecutorSelect = (employee: any, name: string) => {
  //   setFormState((prevState) => ({
  //     ...prevState,
  //     [name]: employee,
  //     council_member:
  //       `${employee?.english_first_name || ""} ${
  //         employee?.english_middle_name || ""
  //       } ${employee?.english_last_name || ""}`.trim() || "Unknown",
  //   }));
  //   setQuery("");
  //   // setShowDropdown(false);
  // };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!litigationData) return;

    setLoading(true);
    // setError(null);
    // setSuccess(false);

    const data = {
      ...formState,
      verdict: litigationData?.id || "",
    };

    try {
      await addCouncilLitigationAttendance(data);

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      // setSuccess(true);
      setFormState({
        council_member: "",
        selected_employee: null,
        was_present: "true",
        remark: "",
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
      // setError(
      //   err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <SideModal isOpen={isOpen} setIsOpen={setIsOpen} title={t("addAttendance")}>
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("name")}
            </label>
            <input
              required
              name="council_member"
              value={formState.council_member}
              onChange={handleChange}
              placeholder={t("name")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>

          {formState?.selected_employee && (
            <div className="relative border-2 border-red-400 bg-white rounded-md p-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <img
                    src={require("../../../images/avatar.png")}
                    alt="avatar"
                    className="w-8 h-8 rounded-full"
                  />
                  <div>
                    <p className="font-medium text-sm">
                      {typeof formState?.selected_employee === "object" &&
                      formState?.selected_employee !== null
                        ? `${
                            formState.selected_employee.english_first_name ||
                            "-"
                          } ${
                            formState.selected_employee.english_middle_name ||
                            "-"
                          } ${
                            formState.selected_employee.english_last_name || "-"
                          }`
                        : "-"}
                    </p>
                    <p className="text-xs text-gray-500">
                      {/* {typeof formState?.selected_employee === "object" &&
                        formState?.selected_employee !== null
                          ? formState.selected_employee.employee_type?.name ||
                            "-"
                          : "-"} */}
                    </p>
                  </div>
                </div>
                <button
                  className="text-gray-400 hover:text-red-600 text-lg font-bold"
                  onClick={() =>
                    setFormState((prev) => ({
                      ...prev,
                      council_member: "",
                      selected_employee: null,
                    }))
                  }
                >
                  ×
                </button>
              </div>
            </div>
          )}

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("wasPresent")}
            </label>
            <select
              required
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
              name="was_present"
              value={formState.was_present}
              onChange={handleChange}
            >
              <option value={"true"}>{t("yes")}</option>
              <option value={"false"}>{t("no")}</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("remark")}
            </label>
            <textarea
              required
              rows={7}
              name="remark"
              value={formState.remark}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("addAttendance")
          )}
        </button>
      </form>
    </SideModal>
  );
}
